export const getJqlTerm = (fieldId: string) => {
	// custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
	if (fieldId.indexOf('customfield_') === 0) {
		const customFieldId = fieldId.split('customfield_')[1];
		return `cf[${customFieldId}]`;
	}

	return fieldId;
};
